import { Component, Input } from '@angular/core';
import { EmdSelectionService } from '../emd-selection.service';

/**
 * Confirm / cancel bar for an in-progress selection, matching Qlik Sense:
 * while the user is clicking values a selection is staged, and this bar lets
 * them apply it (✓) or discard it (×).
 *
 * One instance sits in each cross-filtering widget's header (via
 * emd-widget-header's `selectionOrigin`), and only the widget the user is
 * actually selecting in shows it — `origin` is matched against the id the
 * staging click reported. Confirm/cancel go straight to the service, which
 * owns the apply logic, so no intent needs routing up through the shell.
 */
@Component({
    selector: 'emd-selection-toolbar',
    templateUrl: './emd-selection-toolbar.component.html',
    styleUrls: ['./emd-selection-toolbar.component.scss'],
    standalone: false
})
export class EmdSelectionToolbarComponent {
  /** Widget id this toolbar belongs to; empty shows it for any pending selection. */
  @Input() origin = '';

  constructor(public selection: EmdSelectionService) {}

  get visible(): boolean {
    return this.selection.hasPending && (!this.origin || this.selection.origin === this.origin);
  }

  get count(): number {
    return this.selection.pendingChips().length;
  }

  get label(): string {
    const chips = this.selection.pendingChips();
    if (chips.length === 1) { return chips[0].value; }
    return `${chips.length} selections`;
  }
}
